import { parseUrlParams } from '../utils';
export default () => {
    const params = parseUrlParams(window.location.href);
    return {
        ...params
    };
};
